import { LoadableAfterPaint } from '@confluence/loadable';

export const EmojiTitleButtonLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcemoji-titleEmojiTitleButton" */ '../src/emoji-title/EmojiTitleButton.tsx'
			)
		).EmojiTitleButton,
});
